const Wall = { "flow": "A", "combo": "1" };

const TieneCredencialPremiumBlack = (flowActivarResponse) => {
    if (flowActivarResponse && flowActivarResponse.code) {
        return ["25", "26", "28"].some(x => x == flowActivarResponse.code);
    } else
        return false;
}


export default { Wall, TieneCredencialPremiumBlack }
